import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { FornecedorService } from '../services/fornecedor.service';
import { ProdutoEntradaService } from '../services/produto-entrada.service';
import { ProdutoService } from '../services/produto.service';

import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-produto-entrada-edit',
	templateUrl: './produto-entrada-edit.component.html',
	styleUrls: ['./produto-entrada-edit.component.css'],
	animations: [loadingFade]
})
export class ProdutoEntradaEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public produto_entrada_id = null;
	public produtos;
	public fornecedores;
	public codigoProduto = '';

	public formEntrada: FormGroup;

	// datepickers
	public data_dp;

	//filtro
	public produto_entrada_nf___nota = null;
	public produto_id___produto = null;
	public produto_entrada_data___data_i = null;
	public produto_entrada_data___data_f = null;	
	public href: string = "";
	public hiddenSubmit = false;

	constructor(private authSvc: AuthService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private router: Router,
		private fornecedorSvc: FornecedorService,
		private produtoEntradaSvc: ProdutoEntradaService,
		private produtoSvc: ProdutoService) { }

	ngOnInit() {

        this.href = this.router.url;
        let path = this.router.url;	
		let pathS = path.split("/"); 

		this.pegaProdutos();
		if(pathS[3] == "ver"){
			this.criaFormDisabled();
			this.hiddenSubmit = true;
		}else{
			this.criaForm();
		}

		
		//this.criaForm();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {



				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "produto_entrada_nf___nota": { 
						 this.produto_entrada_nf___nota = loSplitValor[1];
						 break; 
					  } 
					  case "produto_id___produto": { 
						this.produto_id___produto = loSplitValor[1];
						 break; 
					  } 
					  case "produto_entrada_data___data_i": { 
						this.produto_entrada_data___data_i = loSplitValor[1];
						 break; 
					  }      
					  case "produto_entrada_data___data_f": { 
						this.produto_entrada_data___data_f = loSplitValor[1];
						 break; 
					  }      
                                                      
				   }
		
				  }
		
		
				}				


				this.produto_entrada_id = params.id;
				// pega dados a partir do id
				this.produtoEntradaSvc.getProdutoEntrada(params.id).then((data: any) => {
					let data_entrada = null
					if (moment(data.produto_entrada_data).isValid()) {
						let moment_date = moment(data.produto_entrada_data, 'YYYY-MM-DD');
						data_entrada = moment_date.format('DD/MM/YYYY');

						if(pathS[3] != "ver"){
							this.data_dp.setDate(moment_date.toDate());
						}

						
					}

					this.preencheForm({
						produto_entrada_id: data.produto_entrada_id,
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						produto_id: data.produto_id,
						codigoProduto: data.produto.produto_codigo,
						produto_entrada_data: data_entrada,
						produto_entrada_nf: data.produto_entrada_nf,
						produto_entrada_quantidade: data.produto_entrada_quantidade,
						produto_entrada_valor_unit: data.produto_entrada_valor_unit,
						produto_entrada_valor_total: data.produto_entrada_quantidade * data.produto_entrada_valor_unit
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	pegaProdutos() {
		this.produtoSvc.getProdutos().then((data: any) => {
			this.produtos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formEntrada.setValue(dados);
	}

	criaForm() {
		this.formEntrada = this.fb.group({
			produto_entrada_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			produto_id: [null, Validators.required],
			codigoProduto: '',
			produto_entrada_quantidade: [null, Validators.required],
			produto_entrada_data: [null, Validators.required],
			produto_entrada_nf: ['', Validators.required],
			produto_entrada_valor_unit: ['', Validators.required],
			produto_entrada_valor_total: 0
		});

		moment.locale('pt-Br');
		this.data_dp = Datepicker('#produto_entrada_data', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formEntrada.controls['produto_entrada_data'].setValue(formatted);
			}
		});
	}


	criaFormDisabled() {
		this.formEntrada = this.fb.group({
			produto_entrada_id: null,
			usuario_id: {value: null, disabled: true},
			unidade_id: {value: null, disabled: true},
			cliente_id: {value: null, disabled: true},
			produto_id: {value: null, disabled: true},
			codigoProduto: '',
			produto_entrada_quantidade: {value: null, disabled: true},
			produto_entrada_data: {value: null, disabled: true},
			produto_entrada_nf: {value: null, disabled: true},
			produto_entrada_valor_unit: {value: null, disabled: true},
			produto_entrada_valor_total: {value: null, disabled: true}
		});

	}

	enviaEntrada() {
		if (this.formEntrada.valid) {
			this.submitting = true;

			let toSend = this.formEntrada.value;
			toSend['produto_entrada_data_gravacao'] = moment().format('DD/MM/YYYY');
			if (this.produto_entrada_id === null) { // criar
				this.produtoEntradaSvc.criaProdutoEntrada(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Entrada cadastrada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/produto-entrada']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text:'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.produtoEntradaSvc.editaProdutoEntrada(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Entrada alterada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/produto-entrada']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text:'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formEntrada.controls){
				let campo = this.formEntrada.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type:'error',
				title:'Atenção!',
				text:'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	onChangeProduto(e) {
		this.formEntrada.controls['codigoProduto'].setValue(e.produto_codigo);
	}

	invalid(nome) {
		let input = this.formEntrada.get(nome);
		return input.touched && input.invalid;
	}

	atualizaTotal(){
		this.formEntrada.get('produto_entrada_valor_total').setValue(this.formEntrada.get('produto_entrada_quantidade').value * this.formEntrada.get('produto_entrada_valor_unit').value);
	}


	onClickVoltar(){

		let params = 'produto_entrada_nf___nota=' + this.produto_entrada_nf___nota;
		params += "&produto_id___produto=" + this.produto_id___produto;
		params += "&produto_entrada_data___data_i=" + this.produto_entrada_data___data_i;
		params += "&produto_entrada_data___data_f=" + this.produto_entrada_data___data_f;

	
		this.router.navigate(['/home/produto-entradafiltro/' + params]);
	
	  }	  
	
}
